import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import Antd from "ant-design-vue";
import "ant-design-vue/dist/reset.css";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
dayjs.locale("ko");
const app = createApp(App);
export const t = (key, ...args) => i18n.global.t(key, ...args);
app.use(store);
app.use(router);
app.use(Antd);
app.use(i18n); // 注册 i18n

app.mount("#app");
